var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex } from '@syncfusion/ej2-base';
/**
 * Sets and gets the options for customizing the fonts.
 */
export class Font extends ChildProperty {
}
__decorate([
    Property('16px')
], Font.prototype, "size", void 0);
__decorate([
    Property('')
], Font.prototype, "color", void 0);
__decorate([
    Property('Segoe UI')
], Font.prototype, "fontFamily", void 0);
__decorate([
    Property('Regular')
], Font.prototype, "fontWeight", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontStyle", void 0);
__decorate([
    Property(1)
], Font.prototype, "opacity", void 0);
/**
 * Sets and gets the margin for the linear gauge.
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(10)
], Margin.prototype, "left", void 0);
__decorate([
    Property(10)
], Margin.prototype, "right", void 0);
__decorate([
    Property(10)
], Margin.prototype, "top", void 0);
__decorate([
    Property(10)
], Margin.prototype, "bottom", void 0);
/**
 * Sets and gets the options to customize the border for the linear gauge.
 */
export class Border extends ChildProperty {
}
__decorate([
    Property(null)
], Border.prototype, "color", void 0);
__decorate([
    Property(0)
], Border.prototype, "width", void 0);
/**
 * Sets and gets the options for customizing the annotation in linear gauge.
 */
export class Annotation extends ChildProperty {
}
__decorate([
    Property('')
], Annotation.prototype, "content", void 0);
__decorate([
    Property(0)
], Annotation.prototype, "x", void 0);
__decorate([
    Property(0)
], Annotation.prototype, "y", void 0);
__decorate([
    Property('None')
], Annotation.prototype, "verticalAlignment", void 0);
__decorate([
    Property('None')
], Annotation.prototype, "horizontalAlignment", void 0);
__decorate([
    Property('-1')
], Annotation.prototype, "zIndex", void 0);
__decorate([
    Complex({ size: '12px', color: null }, Font)
], Annotation.prototype, "font", void 0);
__decorate([
    Property(null)
], Annotation.prototype, "axisIndex", void 0);
__decorate([
    Property(null)
], Annotation.prototype, "axisValue", void 0);
/**
 * Sets and gets the options for customizing the container of linear gauge.
 */
export class Container extends ChildProperty {
}
__decorate([
    Property('Normal')
], Container.prototype, "type", void 0);
__decorate([
    Property(0)
], Container.prototype, "height", void 0);
__decorate([
    Property(0)
], Container.prototype, "width", void 0);
__decorate([
    Property(10)
], Container.prototype, "roundedCornerRadius", void 0);
__decorate([
    Property('transparent')
], Container.prototype, "backgroundColor", void 0);
__decorate([
    Complex({ width: 1, color: null }, Border)
], Container.prototype, "border", void 0);
__decorate([
    Property(0)
], Container.prototype, "offset", void 0);
/**
 * Sets and gets the options to customize the tooltip for range in axis.
 */
export class RangeTooltip extends ChildProperty {
}
__decorate([
    Property(null)
], RangeTooltip.prototype, "fill", void 0);
__decorate([
    Complex({ size: '13px' }, Font)
], RangeTooltip.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], RangeTooltip.prototype, "format", void 0);
__decorate([
    Property(null)
], RangeTooltip.prototype, "template", void 0);
__decorate([
    Property(true)
], RangeTooltip.prototype, "enableAnimation", void 0);
__decorate([
    Complex({}, Border)
], RangeTooltip.prototype, "border", void 0);
__decorate([
    Property('End')
], RangeTooltip.prototype, "position", void 0);
__decorate([
    Property(false)
], RangeTooltip.prototype, "showAtMousePosition", void 0);
/**
 * Sets and gets the options for customizing the tooltip in linear gauge.
 */
export class TooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], TooltipSettings.prototype, "enable", void 0);
__decorate([
    Property('')
], TooltipSettings.prototype, "fill", void 0);
__decorate([
    Complex({ color: '', size: '13px' }, Font)
], TooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "format", void 0);
__decorate([
    Property(false)
], TooltipSettings.prototype, "showAtMousePosition", void 0);
__decorate([
    Complex({}, RangeTooltip)
], TooltipSettings.prototype, "rangeSettings", void 0);
__decorate([
    Property('End')
], TooltipSettings.prototype, "position", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "template", void 0);
__decorate([
    Property(true)
], TooltipSettings.prototype, "enableAnimation", void 0);
__decorate([
    Complex({}, Border)
], TooltipSettings.prototype, "border", void 0);
__decorate([
    Property('Pointer')
], TooltipSettings.prototype, "type", void 0);
